<script>
  import { Raycaster, Vector2 } from 'three'
  import { createEventDispatcher } from 'svelte'
  import { renderable } from './three-viz.js'

  const dispatch = createEventDispatcher()

  renderable({
    setup: props => {
      const { canvas, camera, scene, width, height } = props

      const raycaster = new Raycaster()

      let mousePosition = new Vector2()

      //add listener for mouse move
      canvas.addEventListener('mousemove', (event) => {
        mousePosition.x = ( event.clientX / width ) * 2 - 1
        mousePosition.y = - ( event.clientY / height ) * 2 + 1

        raycaster.setFromCamera(mousePosition, camera)

        dispatch('objectsHover', raycaster.intersectObjects(scene.children))
      })
    },
  })
</script>
